<ng-container *ngIf="(fsEnabled$ | async) === false">
  <!-- Full screen disabled -->
  <button (click)="triggerFullScreen()" app-mat-icon-button>
    <span class="ri-enter-fullscreen"></span>
  </button>
</ng-container>

<ng-container *ngIf="(fsEnabled$ | async) === true">
  <!-- Full screen enabled -->
  <button (click)="exitFullscreen()" app-mat-icon-button>
    <span class="ri-exit-fullscreen"></span>
  </button>
</ng-container>
